import { Dispatch } from 'redux';
import { CoreApi } from '../../../api/api.apiclient';
import { GET_ACRISS_CODES } from '../types/carClass.types';

export const getAllCarClasses = () => async (dispatch: Dispatch<any>) => {

  const response = await CoreApi.CarModels.listAllAcrissCodes(0);

  dispatch({
    type: GET_ACRISS_CODES,
    payload: { acrissCodes: response }
  });

  return Promise.resolve();
};